import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const benchmarkSelector = ({ benchmark }: ReducerState) => benchmark;
export const benchmarkLoadingSelector = createSelector(
  benchmarkSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
